import { render, staticRenderFns } from "./ActivationIndex.vue?vue&type=template&id=28da8d46&"
import script from "./ActivationIndex.vue?vue&type=script&lang=js&"
export * from "./ActivationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports